import {
	AuthKeys,
	GetObjectResponse,
	CreateObjectRequest,
	ListObjectsResponse,
	ResponseAction,
	GetListRequest,
	GetListSegmentRequest,
	ListSegmentsResponse,
} from '../types';
import { fetchData } from '../fetchService';
import { toSearchParams } from '../helpers/common';

const objectService = {
	async create(
		baseUrl: string,
		object: string,
		authKeys: AuthKeys,
		data?: CreateObjectRequest,
	): Promise<ResponseAction> {
		return await fetchData(
			`${baseUrl}/object?object=${object}`,
			'POST',
			data,
			authKeys,
		);
	},
	async get(
		baseUrl: string,
		object: string,
		authKeys: AuthKeys,
	): Promise<GetObjectResponse> {
		return await fetchData(
			`${baseUrl}/object?object=${object}`,
			'GET',
			null,
			authKeys,
		);
	},
	async delete(
		baseUrl: string,
		object: string,
		authKeys: AuthKeys,
	): Promise<ResponseAction> {
		return await fetchData(
			`${baseUrl}/object?object=${object}`,
			'DELETE',
			null,
			authKeys,
		);
	},
	async getList(
		baseUrl: string,
		authKeys: AuthKeys,
		data?: GetListRequest,
	): Promise<ListObjectsResponse> {
		const query = toSearchParams({ ...data });
		return await fetchData(
			`${baseUrl}/object/match${query ? `?${query}` : ''}`,
			'GET',
			null,
			authKeys,
		);
	},
	async getSegmentList(
		baseUrl: string,
		authKeys: AuthKeys,
		data?: GetListSegmentRequest,
	): Promise<ListSegmentsResponse> {
		const query = toSearchParams({ ...data });
		return await fetchData(
			`${baseUrl}/object/segment${query ? `?${query}` : ''}`,
			'GET',
			null,
			authKeys,
		);
	},
};

export default objectService;
